import { WebSocketClient } from "./WebSocketClient.mjs";

/**
 * @fires topicMessage
 * @fires processedMessage
 * @fires error
 * @fires close
 * @fires open
 */
class DeltaServerWebSocketClient extends WebSocketClient {
    constructor(wsUrl, logger, authenticate) {
        super(wsUrl, logger, 'frank_delta.v1', ['processedMessage', 'topicMessage-*'], authenticate);
    }
    #_getTopicNameFromTopicAndProjection(topic, projection) {
        let topicName = topic;
        if (projection) {
            const projectionString = JSON.stringify(projection);
            const projectionStringAsBase64 = btoa(projectionString);
            topicName = `${topic}-${projectionStringAsBase64}`;
        }
        return topicName;
    }
    subscribeToTopicWithProjection(topic, projection, topicMessageHandler) {
        this.send(JSON.stringify({ type: 'subscribe-to-topic', topic, projection }));
        const topicName = this.#_getTopicNameFromTopicAndProjection(topic, projection)
        this.on(`topicMessage-${topicName}`, topicMessageHandler);
    }
    unsubscribeFromTopicWithProjection(topic, projection, topicMessageHandler) {
        this.send(JSON.stringify({ type: 'unsubscribe-from-topic', topic, projection }));
        const topicName = this.#_getTopicNameFromTopicAndProjection(topic, projection)
        this.off(`topicMessage-${topicName}`, topicMessageHandler);
    }
    subscribeToTopic(topicName, topicMessageHandler) {
        this.send(JSON.stringify({ type: 'subscribe-to-topic', topic: topicName }));
        this.on(`topicMessage-${topicName}`, topicMessageHandler);
    }
    unsubscribeFromTopic(topicName, topicMessageHandler) {
        this.off(`topicMessage-${topicName}`, topicMessageHandler);
    }
    processMessageEvent(event) {
        try {
            const data = JSON.parse(event.data);
            //Send ACK to delta server
            if (data.type === 'delta') {
                let eventData = JSON.stringify({ type: 'ack-delta-event', timingInfo: data.timingInfo });
                this.send(eventData);
                this.trigger(`topicMessage-${data.topic}`, data);
            }
            this.trigger('processedMessage', data);
        }
        catch (e) {
            this.trigger('error', e);
        }
    }
}
export { DeltaServerWebSocketClient };
export default DeltaServerWebSocketClient;